import { render, staticRenderFns } from "./VorstossSignDialog.vue?vue&type=template&id=ea28dc2a"
import script from "./VorstossSignDialog.vue?vue&type=script&lang=js"
export * from "./VorstossSignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports